import React from 'react';
import {useProviderProfile} from "../../../../../ProviderProfileProvider";
import {KensuTable} from "../../../../../components/table/KensuTable";
import {TabbedPageHeader} from "../../../../../components/TabbedPageHeader";
import {useCatalogTabs} from "../CatalogRouter";

import {useNavigateWithParams} from "../../../../../util/NavUtils";
import {priceToString} from "../../../../../util/PriceUtil";

export const ClassTemplates = () => {

  const {businessProfile} = useProviderProfile();
  const navigate = useNavigateWithParams();
  const catalogTabs = useCatalogTabs();

  return <div className={'NonScrollingToolPage'}>

    <TabbedPageHeader pageTitle={'Catalog'}
                      buttons={[{text: 'Add Class', link: 'add'}]}
                      tabs={catalogTabs}/>

    <div className={'ProviderToolAreaContent'}>

      Let’s help your clients discover your offerings. Here's where you curate your classes, services and packages.
      <br/><br/>

      <KensuTable data={businessProfile?.studio?.classTemplates}
                  onRowSelected={(row) => navigate(`/home/catalog/classes/edit/${row.classTemplateId}`)}
                  columns={[
                    {
                      label: 'Name',
                      render: (r) => r.name,
                      sortString: r => r.name,
                      showArchivedBadge: r => r.archived
                    },
                    {label: 'Category', render: r => r.category, sortString: r => r.category},
                    {label: 'Length', render: r => r.lengthMinutes + ' min', sortOrder: r => r.lengthMinutes},
                    {label: 'Price', render: r => priceToString(r.paymentPolicy?.prepaid?.price, true)},
                  ]}
      />

      {!businessProfile?.studio?.classTemplates?.length && <div>
        <br/>
        <b>No classes listed yet. </b> Click <b>“Add”</b> to create your first class template and begin shaping your
        studio.
      </div>}

    </div>
  </div>

};

